import React, {useEffect} from 'react'
import {Link} from 'react-scroll'


function Submenu({categories}) {

    function updateElement(){
        let element = document.querySelector('ul > li > a.active');
        let submenuContainer = document.getElementById("test");
        //let offset = element.offsetLeft + element.outerWidth/2 + submenuContainer.scrollLeft - submenuContainer.width/2;
        //let offset = Math.floor(Math.random()*1000)
        //submenuContainer.scroll(offset, 0)
        //console.log(element);
        //console.log(element.offsetLeft);
    }

    useEffect(() => {
        window.addEventListener('scroll', updateElement)
    }, [])

    return (
    <section className="submenu">
        <div className="container flex" id="test">
            <nav>
                <ul>
                {categories.map((category, index) => {
                    return (
                        <li className="ahoj" key={index}><Link activeClass="active" to={"#"+category} smooth={true} duration={500} spy={true} exact={true} offset={-140}>{category}</Link></li>
                    );
                })}
                </ul>
            </nav>
        </div>
    </section>
    )
}

export default Submenu
